/* ============================================================
   PIVOT SPORTSWEAR CO. — theme behaviour
   Cart drawer talks to Shopify's AJAX Cart API, so stock,
   pricing, discounts and checkout are all Shopify's.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.PVT || {};
  /* Shopify's standard routes as a floor, so the cart still works if the
     layout's config block is ever edited out or moved. */
  var DEFAULTS = {
    cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart',
    checkout: '/checkout', shop: '/collections/all'
  };
  var ROUTES = {};
  Object.keys(DEFAULTS).forEach(function (k) { ROUTES[k] = DEFAULTS[k]; });
  Object.keys(CFG.routes || {}).forEach(function (k) {
    if (CFG.routes[k]) ROUTES[k] = CFG.routes[k];
  });
  var STR = CFG.strings || {};

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    function num(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholder);
    switch (match && match[1]) {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = num(cents, 2, ' ', '.'); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  window.PivotMoney = formatMoney;

  /* ---------- stars ---------- */
  function starsSvg(rating) {
    var out = '<span class="stars" aria-label="' + rating + ' out of 5">';
    for (var i = 0; i < 5; i++) {
      var full = i < Math.round(rating);
      out += '<svg viewBox="0 0 24 24"' + (full ? '' : ' style="opacity:.25"') +
        '><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    return out + '</span>';
  }

  /* ============================================================
     CART — Shopify AJAX API
     ============================================================ */
  var Cart = {
    data: null,

    fetch: function () {
      return fetch(ROUTES.cart + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) { Cart.data = c; Cart.render(); } return c; })
        .catch(function () { return null; });
    },

    add: function (variantId, qty, properties) {
      if (!variantId) return Promise.resolve();
      var body = { id: Number(variantId), quantity: qty || 1 };
      if (properties) body.properties = properties;
      return fetch(ROUTES.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.body.description || res.body.message || 'Could not add to bag'); return; }
          return Cart.fetch().then(function () {
            toast((res.body.product_title || res.body.title || '') + ' ' + (STR.added || 'added'));
            openDrawer();
          });
        })
        .catch(function () { toast('Could not add to bag'); });
    },

    change: function (line, qty) {
      return fetch(ROUTES.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) { Cart.data = c; Cart.render(); });
    },

    render: function () {
      var c = Cart.data; if (!c) return;

      $$('.cart-count').forEach(function (el) {
        el.textContent = c.item_count;
        el.classList.toggle('on', c.item_count > 0);
      });

      var body = $('#drawerBody'), ft = $('#drawerFoot');
      if (!body) return;

      if (!c.item_count) {
        body.innerHTML = '<div class="empty"><p>' + (STR.empty || 'Your bag is empty') + '</p>' +
          '<a class="btn btn-ghost" href="' + ROUTES.shop + '">' + (STR.shopDrop || 'Shop the drop') + '</a></div>';
        if (ft) ft.style.display = 'none';
      } else {
        if (ft) ft.style.display = '';
        body.innerHTML = c.items.map(function (it, i) {
          var img = it.image
            ? it.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_160x$1$2')
            : '';
          var variant = (it.options_with_values || [])
            .filter(function (o) { return o.value && o.value !== 'Default Title'; })
            .map(function (o) { return o.value; }).join(' · ');
          return '<div class="ci">' +
            (img ? '<img src="' + img + '" alt="' + escapeHtml(it.product_title) + '" width="78" height="88">' : '<div></div>') +
            '<div><h4><a href="' + it.url + '">' + escapeHtml(it.product_title) + '</a></h4>' +
            (variant ? '<div class="v">' + escapeHtml(variant) + '</div>' : '<div class="v"></div>') +
            '<div class="ci-btm"><div class="qty">' +
            '<button data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
            '<span class="p">' + formatMoney(it.final_line_price) + '</span></div>' +
            '<button class="rm" data-line="' + (i + 1) + '" data-qty="0">' + (STR.remove || 'Remove') + '</button></div></div>';
        }).join('');
      }

      var st = $('#subTotal'); if (st) st.innerHTML = formatMoney(c.total_price);

      var threshold = CFG.freeShipThreshold || 0;
      var txt = $('#shipTxt'), bar = $('#shipBar');
      if (threshold > 0 && txt) {
        var left = Math.max(0, threshold - c.total_price);
        txt.innerHTML = left > 0
          ? (STR.freeShipAway || 'You are {{ amount }} from free shipping').replace('{{ amount }}', '<b>' + formatMoney(left) + '</b>')
          : '<b>' + (STR.freeShipUnlocked || 'Free shipping unlocked') + '</b> &check;';
        if (bar) bar.style.width = Math.min(100, (c.total_price / threshold) * 100) + '%';
      } else if (txt) {
        txt.closest('.ship-meter').style.display = 'none';
      }
    }
  };
  window.PivotCart = Cart;

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  /* ============================================================
     DRAWER + TOAST
     ============================================================ */
  function openDrawer() {
    var s = $('#pvtScrim'), d = $('#pvtDrawer'); if (!s) return;
    s.classList.add('on'); d.classList.add('on');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var close = $('#pvtClose'); if (close) close.focus();
  }
  function closeDrawer() {
    var s = $('#pvtScrim'), d = $('#pvtDrawer'); if (!s) return;
    s.classList.remove('on'); d.classList.remove('on');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }
  window.PivotOpenCart = openDrawer;

  var toastT;
  function toast(msg) {
    var el = $('#pvtToast'); if (!el) return;
    $('#toastMsg').textContent = msg;
    el.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('on'); }, 2800);
  }
  window.PivotToast = toast;

  /* ============================================================
     PDP — variant picker
     ============================================================ */
  function initPDP() {
    var root = $('[data-pdp]'); if (!root) return;

    var variants = [];
    var jsonEl = $('#PdpVariants', root);
    if (jsonEl) { try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; } }

    var selected = {};
    $$('[data-opt-group]', root).forEach(function (group) {
      var idx = group.getAttribute('data-opt-group');
      var on = $('[aria-checked="true"], .on', group);
      if (on) selected[idx] = on.getAttribute('data-value');
    });

    function currentVariant() {
      var keys = Object.keys(selected);
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var k = 0; k < keys.length; k++) {
          if (v.options[Number(keys[k])] !== selected[keys[k]]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function paint() {
      var v = currentVariant();
      var addBtns = $$('[data-pdp-add]');
      var priceEl = $('#PdpPrice'), compareEl = $('#PdpCompare'), offEl = $('#PdpOff');

      if (!v) {
        addBtns.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; });
        return;
      }
      root.setAttribute('data-variant-id', v.id);
      if (priceEl) priceEl.innerHTML = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.innerHTML = formatMoney(v.compare_at_price);
          compareEl.hidden = false;
          if (offEl) {
            offEl.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
            offEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if (offEl) offEl.hidden = true;
        }
      }
      addBtns.forEach(function (b) {
        b.disabled = !v.available;
        b.textContent = v.available
          ? (b.getAttribute('data-label-add') || 'Add to bag') + ' — ' + formatMoney(v.price)
          : (b.getAttribute('data-label-sold') || 'Sold out');
      });

      if (v.featured_media_index != null) selectMedia(v.featured_media_index);

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    function selectMedia(i) {
      var thumbs = $$('#galThumbs button');
      if (!thumbs[i]) return;
      thumbs.forEach(function (t) { t.classList.remove('on'); });
      thumbs[i].classList.add('on');
      var main = $('#galMain'), img = $('img', thumbs[i]);
      if (main && img) {
        main.src = img.getAttribute('data-full') || img.src;
        main.alt = img.alt;
      }
    }

    $$('[data-opt-group]', root).forEach(function (group) {
      var idx = group.getAttribute('data-opt-group');
      group.addEventListener('click', function (e) {
        var b = e.target.closest('[data-value]');
        if (!b || b.classList.contains('out') || b.disabled) return;
        $$('[data-value]', group).forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('on'); b.setAttribute('aria-checked', 'true');
        selected[idx] = b.getAttribute('data-value');
        var label = $('[data-opt-label="' + idx + '"]');
        if (label) label.textContent = selected[idx];
        paint();
      });
    });

    /* gallery */
    $$('#galThumbs button').forEach(function (b, i) {
      b.addEventListener('click', function () { selectMedia(i); });
    });
    selectMedia(0);

    /* qty */
    var qEl = $('#pdpQty'), qty = 1;
    var dec = $('#qDec'), inc = $('#qInc');
    if (dec) dec.addEventListener('click', function () { qty = Math.max(1, qty - 1); qEl.textContent = qty; });
    if (inc) inc.addEventListener('click', function () { qty = Math.min(99, qty + 1); qEl.textContent = qty; });

    $$('[data-pdp-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = root.getAttribute('data-variant-id');
        Cart.add(id, qty);
      });
    });

    var buyNow = $('#pdpBuyNow');
    if (buyNow) buyNow.addEventListener('click', function (e) {
      e.preventDefault();
      Cart.add(root.getAttribute('data-variant-id'), qty).then(function () {
        window.location.href = ROUTES.checkout;
      });
    });

    /* sticky bar appears once the main ATC scrolls past */
    var bar = $('#stickyBar'), anchor = $('[data-pdp-add]');
    if (bar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        bar.classList.toggle('on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
    }

    paint();
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    Cart.fetch();

    /* fill star ratings */
    $$('[data-stars]').forEach(function (el) {
      el.outerHTML = starsSvg(parseFloat(el.getAttribute('data-stars')) || 5);
    });

    /* mobile nav */
    var burger = $('#burger'), nav = $('#nav');
    if (burger) burger.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    /* drawer wiring */
    var scrim = $('#pvtScrim'), close = $('#pvtClose');
    if (scrim) scrim.addEventListener('click', closeDrawer);
    if (close) close.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    var dBody = $('#drawerBody');
    if (dBody) dBody.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]'); if (!b) return;
      Cart.change(Number(b.getAttribute('data-line')), Number(b.getAttribute('data-qty')));
    });

    /* global click handlers */
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-cart-open]');
      if (open) { e.preventDefault(); openDrawer(); return; }

      var add = e.target.closest('[data-add-variant]');
      if (add) {
        e.preventDefault();
        var id = add.getAttribute('data-add-variant');
        if (!id) return;
        add.disabled = true;
        Cart.add(id, 1).then(function () { add.disabled = false; });
        return;
      }

      var notify = e.target.closest('[data-notify]');
      if (notify) { e.preventDefault(); toast(STR.notify || 'We will email you when it drops'); }
    });

    /* newsletter forms fall back to a success state if JS-only */
    $$('[data-capture-msg]').forEach(function (f) {
      f.addEventListener('submit', function () {
        /* Shopify's customer form posts natively; nothing to intercept */
      });
    });

    /* scroll reveal — failsafe so content can never stay hidden */
    var revealAll = function () { $$('.reveal').forEach(function (el) { el.classList.add('in'); }); };
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
      $$('.reveal').forEach(function (el) { io.observe(el); });
      setTimeout(revealAll, 2500);
    } else {
      revealAll();
    }

    /* first-visit offer */
    var offer = $('#pvtOffer');
    if (offer) {
      var shown = false, seen = false;
      try { seen = window.sessionStorage.getItem('pvt_offer') === '1'; } catch (e) { }
      var show = function () { if (!shown && !seen) { shown = true; offer.classList.add('on'); } };
      var t = setTimeout(show, 14000);
      var onScroll = function () {
        if ((window.scrollY + window.innerHeight) / document.body.scrollHeight > .55) {
          show(); window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      var x = $('#offerX');
      if (x) x.addEventListener('click', function () {
        clearTimeout(t); offer.classList.remove('on');
        try { window.sessionStorage.setItem('pvt_offer', '1'); } catch (e) { }
      });
    }

    initPDP();

    /* theme editor: re-init when a section is re-rendered */
    document.addEventListener('shopify:section:load', function () {
      Cart.render();
      initPDP();
      revealAll();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
